import { ForcedState, useForcedState, useTranslation } from '@wix/form-fields';
import React from 'react';
import { useSubmitStatus } from '../../contexts/submit-status-context';
import { FadeOut } from './fade-out';
import { SubmitErrorMessage } from './submit-error-message';
import styles from './submit-status-message.module.scss';
import { SubmitThankYouMessage } from './submit-thank-you-message';
export const SubmitStatusMessage = ({ thankYouMessage })=>{
    const { isSubmitting, submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
    const { t } = useTranslation();
    const forcedState = useForcedState();
    const isSuccessMessageForced = forcedState.includes(ForcedState.SUCCESS_MESSAGE);
    const isErrorMessageForced = forcedState.includes(ForcedState.ERROR_MESSAGE);
    const successMessage = submitSuccessMessage ?? (isSuccessMessageForced ? thankYouMessage : undefined);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        role: "status"
    }, isSubmitting && /*#__PURE__*/ React.createElement("span", {
        className: styles.visuallyHidden
    }, t('form.submit-button.state.in-progress')), /*#__PURE__*/ React.createElement(FadeOut, {
        visible: !!successMessage
    }, /*#__PURE__*/ React.createElement(SubmitThankYouMessage, {
        messageText: successMessage
    }))), /*#__PURE__*/ React.createElement("div", {
        role: "alert"
    }, /*#__PURE__*/ React.createElement(SubmitErrorMessage, {
        errorMessageCode: submitFailureCode,
        errorMessage: submitFailureMessage,
        forced: isErrorMessageForced
    })));
};

//# sourceMappingURL=submit-status-message.js.map